'use client';

import { useState, useEffect } from 'react';

enum ScreenSize {
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  '2XL' = 1536,
  '3XL' = 1920,
}

const getScreenSize = (width: number): ScreenSize => {
  if (width >= ScreenSize['3XL']) return ScreenSize['3XL'];
  if (width >= ScreenSize['2XL']) return ScreenSize['2XL'];
  if (width >= ScreenSize.XL) return ScreenSize.XL;
  if (width >= ScreenSize.LG) return ScreenSize.LG;
  if (width >= ScreenSize.MD) return ScreenSize.MD;
  return ScreenSize.SM;
};

const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.SM);

  useEffect(() => {
    if (!window) {
      return;
    }
    setScreenSize(getScreenSize(window.innerWidth));

    const handleResize = () => {
      setScreenSize(getScreenSize(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export { useScreenSize, ScreenSize };
